import { FC } from 'react'
import { Box, Button, Typography, CircularProgress } from '@mui/material'
import { useParams, Link } from 'react-router-dom'
import { CONTRACT_DOCUMENT_TYPE } from 'services/contracts/contracts.consts'
import AdditionalServicesOnlinePaymentButton from 'components/AdditionalServices/AdditionalServicesOnlinePaymentButton'
import OperationsFrozenMessage from 'components/OperationsFrozenMessage'
import { useInterestNote } from 'services/pay/pay.hooks'
import { useLeaseContractsList } from 'services/contracts/hooks/useLeaseContracts'
import { useIntl } from 'react-intl'

const IntrestnotePayPage: FC = () => {
  const { documentId, id } = useParams()
  const { formatMessage } = useIntl()
  const { getActiveContract } = useLeaseContractsList()
  const isOperationsFrozen = getActiveContract(Number(id))?.isOperationsFrozen

  const {
    interestNoteDetails,
    isLoading: invoiceIsLoading,
    error
  } = useInterestNote({
    id: Number(documentId),
    leaseContractId: Number(id)
  })

  if (invoiceIsLoading && !!invoiceIsLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </Box>
    )
  }

  if (error) {
    return (
      <Box>
        <Typography variant='h5' sx={{ textAlign: 'center' }}>
          {formatMessage({
            id: 'paymentScheduleDocumnet.missingDocument',
            defaultMessage: 'Brak dokumentu'
          })}
        </Typography>
        <Box display='flex' justifyContent='space-between' mt={4}>
          <Button component={Link} to='/'>
            Idź do panelu
          </Button>
        </Box>
      </Box>
    )
  }

  return (
    <Box p={4}>
      <Box>
        <Box>
          <Typography variant='h4'>
            {formatMessage({
              id: 'paymentScheduleDocumnetTitle.interestNote',
              defaultMessage: 'Nota odsetkowa'
            })}
          </Typography>
          <Typography variant='h5'>
            {interestNoteDetails?.number ||
              formatMessage({
                id: 'paymentScheduleDocumnet.awaiting',
                defaultMessage: 'Oczekuje na wystawienie'
              })}
          </Typography>
        </Box>
        <Box sx={{ textAlign: 'right' }}>
          <Typography variant='h5'>
            {formatMessage({
              id: 'paymentScheduleDocumnet.receivable',
              defaultMessage: 'Należność'
            })}
            :
          </Typography>
          <Typography fontWeight={600} mb={2}>
            {interestNoteDetails?.amount} {interestNoteDetails?.currency}
          </Typography>
          <Typography variant='h6'>
            {formatMessage({
              id: 'paymentScheduleDocumnet.paid',
              defaultMessage: 'Opłacono'
            })}
            :
          </Typography>
          <Typography fontWeight={600}>
            {interestNoteDetails?.paymentAmount} {interestNoteDetails?.currency}
          </Typography>
        </Box>
      </Box>
      {isOperationsFrozen && <OperationsFrozenMessage />}
      <Box display='flex' justifyContent='space-between' mt={4}>
        <Button component={Link} to='/'>
          Idź do panelu
        </Button>
        {!isOperationsFrozen &&
          !interestNoteDetails?.isPaid &&
          ['PLN'].includes(interestNoteDetails?.currency ?? '') && (
            <AdditionalServicesOnlinePaymentButton
              documentType={CONTRACT_DOCUMENT_TYPE.interestNote}
              documentId={Number(documentId)}
            />
          )}
      </Box>
    </Box>
  )
}

export default IntrestnotePayPage
